<!--分享内容移动端展示组件，使蓝湖的原型和设计图分享共用一套代码
    @dengli
    @date 2019.3.25
    说明：
        - 该这组件逻辑和proto基本一致，都引入protoItem.vue来展示原型或者设计图
        - 组件动态引入了微信jssdk，支持了微信浏览器页面的二次分享
        - 分享出去的设计图在移动端设备浏览器打开，会自动跳转到该组件页面展示原型
-->
<template>
    <div class="proto_wrap" :class="{ safe_padding: paddingShow }" ref="protoWrapper">
        <slide-bar
            v-if="shareType === 'proto'"
            :pageShare="true"
            :homeId="homeId"
            :show="slideBar"
            @close="closeSlideBar"
            @share="shareShow = true"
        ></slide-bar>
        <v-touch
            class="zone"
            @press="showSlideBar(true, 'press')"
            @doubletap="showSlideBar(true, 'doubletap')"
            @tap="showSlideBar(false)"
        >
            <div class="proto_touch_zone">
                <proto
                    ref="proto"
                    :shareType="shareType"
                    :pageShare="true"
                    :hotspots="hotspots"
                    :image-src="imageSrc"
                    :imgHeight="imgHeight"
                    :layoutData="layoutData"
                    :showHead="system === 'ios' ? showHead : true"
                    :showFoot="system === 'ios' ? showFoot : true"
                ></proto>
            </div>
            <div @touchstart="hideGuide" v-show="protoGuide">
                <div class="proto_guide" :class="{ hide: !guide }"></div>
            </div>
        </v-touch>
    </div>
</template>

<script>
import slideBar from "@/components/layout/SlideBar"
import Proto from "@/views/design/components/ProtoItem"
export default {
    name: "Share",
    components: {
        slideBar,
        Proto
    },
    data() {
        return {
            slideBar: false,
            guide: true,
            hotspots: [],
            layoutData: null,
            protoGuide: null,
            imageSrc: "",
            imgHeight: 0,
            shareShow: false,
            scrollTop: 0,
            scrollHeight: 0,
            protoData: {
                id: "",
                team_id: "",
                pid: "",
                img: "",
                name: ""
            },
            shareInfo: null,
            signatureInfo: {}
        }
    },
    computed: {
        shareType() {
            if (this.$route.query.type && this.$route.query.type === "design") {
                return "design"
            } else {
                return "proto"
            }
        },
        homeId() {
            return this.$route.query.home_id
        },
        direction() {
            return window.vm.device.direction
        },
        system() {
            return window.system
        },
        paddingShow() {
            return this.imgHeight < this.$root.device.size.height
        },
        showHead() {
            if (this.scrollTop <= 0) {
                return false
            } else {
                return true
            }
        },
        showFoot() {
            if (this.scrollHeight && this.scrollHeight <= this.scrollTop + this.$root.device.size.height) {
                return false
            } else {
                return true
            }
        }
    },
    watch: {
        $route() {
            this.getImage()
        }
    },
    created() {
        this.judgeGuide()
    },
    mounted() {
        localStorage.protoGuide = "true"
        localStorage.team_id = this.$route.query.team_id
        if (this.$route.query.home_id) {
            localStorage.homeId = this.$route.query.home_id
        }
        if (this.system === "ios") {
            this.$refs.protoWrapper.addEventListener("scroll", this.judgeHeadFoot)
        }
        this.handleShare()
        this.getImage()
    },
    beforeDestroy() {
        if (this.system === "ios") {
            this.$refs.protoWrapper.removeEventListener("scroll", this.judgeHeadFoot)
        }
    },
    methods: {
        //若为pc端，跳至蓝湖网站预览原型
        judgePc() {
            let userAgentInfo = navigator.userAgent
            let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"]
            let flag = true
            for (let v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false
                    break
                }
            }
            if (flag) {
                location.href = `${location.origin}/web/#/item/board/proto/edit/entry?sId=${
                    this.$route.query.id
                }&team_id=${this.$route.query.team_id}&type=mobile&pid=${this.$route.query.id}`
            }
        },
        isWX() {
            //判断是否是微信
            let ua = navigator.userAgent.toLowerCase()
            return ua.match(/MicroMessenger/i) == "micromessenger"
        },
        handleShare() {
            if (this.isWX()) {
                let wxJs = document.createElement("script")
                wxJs.src = "https://res.wx.qq.com/open/js/jweixin-1.4.0.js"

                let head = document.querySelector("head")
                head.appendChild(wxJs)

                wxJs.onload = () => {
                    this.getSignature()
                }
            }
        },
        async getSignature() {
            try {
                let url = `https://report.${window.domain}.com/api/wechat/js_ticket`
                let res = await axios.get(url, {
                    params: {
                        url: encodeURIComponent(location.href.split("#")[0])
                    }
                })
                let data = res.data.result
                if (data) {
                    console.log("获取签名先关信息:", data)
                    this.signatureInfo = data
                    this.setWxShare()
                }
            } catch (err) {
                // alert("获取签名出错:" + JSON.stringify(err))
                console.log(err)
            }
        },
        setWxShare() {
            this.shareInfo = [
                {
                    title: `${this.protoData.name} - 设计图分享`,
                    desc: `蓝湖，一款帮助产品经理和设计师提高沟通效率的平台.`,
                    link: `${window.baseURL}/webapp/#/share?id=${this.protoData.id}&team_id=${
                        this.protoData.team_id
                    }&type=design`,
                    imgUrl: this.protoData.img
                },
                {
                    title: `${decodeURIComponent(this.$route.query.project_name)} - 原型分享`,
                    desc: "蓝湖，一款帮助产品经理和设计师提高沟通效率的平台.",
                    link: `${window.baseURL}/webapp/#/share?id=${this.protoData.id}&team_id=${
                        this.protoData.team_id
                    }&home_id=${this.homeId}`,
                    imgUrl: this.protoData.img
                }
            ]

            let config = {
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: "wxfdcffd28589f8c8d", // 必填，公众号的唯一标识
                timestamp: this.signatureInfo.timestamp, // 必填，生成签名的时间戳
                nonceStr: this.signatureInfo.noncestr, // 必填，生成签名的随机串
                signature: this.signatureInfo.signature, // 必填，签名
                jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "onMenuShareTimeline",
                    "onMenuShareAppMessage",
                    "onMenuShareQQ",
                    "onMenuShareWeibo",
                    "onMenuShareQZone"
                ] // 必填，需要使用的JS接口列表
            }

            wx.config(config)

            let self = this
            wx.ready(function() {
                self.setShareApi()
            })

            wx.error(function(res) {
                alert("微信JS加载出错:" + JSON.stringify(res) + " 请刷新重试")
            })
        },
        setShareApi() {
            if (this.$route.query.type && this.$route.query.type == "design") {
                wx.updateAppMessageShareData({
                    title: this.shareInfo[0].title, // 分享标题
                    desc: this.shareInfo[0].desc, // 分享描述
                    link: this.shareInfo[0].link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: this.shareInfo[0].imgUrl, // 分享图标
                    success: function() {
                        console.log("设置成功")
                    }
                })
                wx.updateTimelineShareData({
                    title: this.shareInfo[0].title, // 分享标题
                    link: this.shareInfo[0].link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: this.shareInfo[0].imgUrl, // 分享图标
                    success: function() {
                        console.log("设置成功")
                    }
                })
            } else {
                wx.updateAppMessageShareData({
                    title: this.shareInfo[1].title, // 分享标题
                    desc: this.shareInfo[1].desc, // 分享描述
                    link: this.shareInfo[1].link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: this.shareInfo[1].imgUrl, // 分享图标
                    success: function() {
                        console.log("设置成功")
                    }
                })

                wx.updateTimelineShareData({
                    title: this.shareInfo[1].title, // 分享标题
                    link: this.shareInfo[1].link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: this.shareInfo[1].imgUrl, // 分享图标
                    success: function() {
                        console.log("设置成功")
                    }
                })
            }
        },
        judgeHeadFoot() {
            this.scrollTop = this.$refs.protoWrapper.scrollTop
            this.scrollHeight = this.$refs.protoWrapper.scrollHeight
        },
        getImgHeight() {
            document.querySelector("#proto_img").addEventListener("load", () => {
                this.imgHeight = document.querySelector("#proto_img").offsetHeight
            })
        },
        judgeGuide() {
            this.protoGuide = localStorage.protoGuide
        },
        showSlideBar(value, type) {
            this.slideBar = value
            MtaH5.clickStat("menu_trigger", { [type]: "true" })
        },
        closeSlideBar() {
            this.slideBar = false
        },
        // 隐藏引导页
        hideGuide() {
            localStorage.protoGuide = ""
            this.guide = false
        },
        //通过share接口获取图片数据，热区等
        async getImage() {
            this.judgePc()
            let url = `${location.origin}/api/project/share?share_id=${this.$route.query.id}&team_id=${
                this.$route.query.team_id
            }`
            axios.get(url).then(res => {
                if (res) {
                    let data = res.data.result
                    this.hotspots = []

                    data.positions.forEach(ele => {
                        if (ele.next_image) {
                            if (ele.p_h > 1 || ele.p_w > 1 || ele.p_x > 1 || ele.p_y > 1) {
                                ele.p_h = (ele.p_h / ele.height) * 100 + "%"
                                ele.p_w = (ele.p_h / ele.width) * 100 + "%"
                                ele.p_x = (ele.p_h / ele.width) * 100 + "%"
                                ele.p_y = (ele.p_h / ele.height) * 100 + "%"
                            }
                            this.hotspots.push(ele)
                        }
                    })

                    this.imageSrc = window.mtd.handleImg(data.url, {
                        ali: this.$root.isSupportWebp ? "?x-oss-process=image/format,webp" : "",
                        qiniu: ""
                    })
                    if (
                        data.version_layout_data &&
                        JSON.parse(data.version_layout_data).scrollInfo &&
                        (JSON.parse(data.version_layout_data).scrollInfo.topOffset ||
                            JSON.parse(data.version_layout_data).scrollInfo.bottomOffset)
                    ) {
                        this.layoutData = JSON.parse(data.version_layout_data)
                    } else {
                        if (data.layout_data) {
                            this.layoutData = JSON.parse(data.layout_data)
                        } else {
                            this.layoutData = {}
                        }
                    }
                    this.protoData.id = data.share_id
                    this.protoData.name = data.name
                    this.protoData.team_id = this.$route.query.team_id
                    this.protoData.pid = this.$route.query.project_id
                    this.protoData.img = data.url

                    this.getImgHeight()
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.proto_wrap {
    height: 100vh;
    width: 100%;
    overflow-y: auto;
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    background: black;
    &.safe_padding {
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }
    .zone {
        height: 100%;
    }
    .proto_touch_zone {
        min-height: 100%;
        overflow: auto;
    }
    .proto_guide {
        z-index: 1111;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8) url("~@/assets/imgs/guide_proto.png") center center / 50% no-repeat;
        transition: all ease 300ms;

        &.hide {
            opacity: 0;
            z-index: -1;
        }
    }
}
</style>
